// extracted by mini-css-extract-plugin
module.exports = {"map":"_lang__map__fIvul","wrapMapClass":"_lang__wrapMapClass__phfxO","mapBox":"_lang__mapBox__VMZjJ","button":"_lang__button__Tgv7S","mapDistance":"_lang__mapDistance__lXX03"};